/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IconUploadConfirmDialogService } from 'app/services/icon-upload-confirm-dialog-service.service';
import { ServerObjectService } from 'app/services/server-object.service';

declare var $: any;

@Component({
  selector: 'app-icon-upload-confirm-dialog',
  templateUrl: './icon-upload-confirm-dialog.component.html'
})
export class IconUploadConfirmDialog implements OnInit {

  maxIconRes: string;
  loaded: boolean;
  
  constructor(private activeModal: NgbActiveModal, private serverObjectService: ServerObjectService) {}


  ngOnInit(): void {
    this.serverObjectService.getAllServerObjects().then(
      response => {
        for (const object of response) {
          if (object.name == "Edgefinity Server") {
            this.serverObjectService.getAllServerObjectInstances().then(
              responseAllServerObjects => {

                // Find all the fields in the data of settingsDefaultService, and place them into a map with their name
                const settingsDefaultService = {};

                for (const objectInstance of responseAllServerObjects) {
                  if (objectInstance.serverObject && objectInstance.serverObject.id == object.id) {
                    for(const dataElement of objectInstance.data) {
                      if (dataElement.property && dataElement.property.property) {
                        if(dataElement.property.property == 'max_icon_res'){
                          this.maxIconRes = dataElement.value
                          this.loaded = true;
                        }
                    }
                  }
                    break;
                  }
                }
              },
              error => {
                console.error("Could not find the Edgefinity Server Instance");
              }
            );
            break;

          }
        }
      },
      error => {
        console.error("Could not find the Edgefinity Server Object");
      }
    )

  }

  public decline(){
    this.activeModal.close(false);
  }

  public accept(){
    this.activeModal.close(true);
  }

  public dismiss(){
    this.activeModal.dismiss();
  }

}
